/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* refundWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_REFUND_LIST);
  yield takeLatest(ActionConstants.POST_CREATE_REFUND, workerSaga);
  yield takeLatest(ActionConstants.POST_CREATE_V3_REFUND, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_REFUND_BULK_UPLOAD_HISTORY_LIST,
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_REFUND_BULK_UPLOAD_HISTORY_LIST,
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_REF_FILE_REFUND_LIST,
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_ALL_REFUND_STATUS_LIST);
  yield takeLatest(
    ActionConstants.GET_EMI_PRODUCT_DETAILS_FOR_REFUND,
    workerSaga
  );
  yield fork(takeLatestUntilApiCancel, ActionConstants.GET_REFUND_DETAIL);
  yield takeLatest(ActionConstants.POST_CREATE_REFUND_VIA_PAYOUT, workerSaga);
}
